module.exports = __webpack_public_path__ + "static/media/squiggle.831e8736.svg";